// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ILabelSchema {
  /** Текст **/
  text: string;
  /** Тип метки **/
  type: EType;
}
export enum EType {
  /** Бонусы **/
  'Bonus' = 'bonus',
  /** Скидки **/
  'Discount' = 'discount',
  /** Ипотека **/
  'Mortgage' = 'mortgage',
  /** Количество ЖК **/
  'NewbuildingCount' = 'newbuildingCount',
  /** Sale (ЧП) **/
  'Sale' = 'sale',
}
